// extracted by mini-css-extract-plugin
export default {"zoomModal":"Q1-z","image":"R1-z","button":"S1-z","isOverlayShown":"T1-z"};